import { Skeleton, Stack, Text } from '@sixui/ui';

import type { ITableRowProps } from '~/components/molecules/Table/TableRow';
import { UserAvatar } from '~/components/atoms/UserAvatar';
import { Table } from '~/components/molecules/Table';

export type IIapPollVoteListItemSkeletonProps = ITableRowProps;

export const IapPollVoteListItemSkeleton: React.FC<
  IIapPollVoteListItemSkeletonProps
> = (props) => {
  const { ...other } = props;

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} horizontal gap={3}>
        <Skeleton variant="circular">
          <UserAvatar />
        </Skeleton>
        <Stack gap={1}>
          <Text
            as={Skeleton}
            variant="title"
            size="sm"
            length={{ min: 8, max: 24 }}
          />
        </Stack>
      </Stack>

      <Table.Body>
        <Skeleton length={{ min: 24, max: 64 }} />
      </Table.Body>

      <Table.Body>
        <Skeleton length={{ min: 8, max: 12 }} />
      </Table.Body>
    </Table.Row>
  );
};
